// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1j6nT","rootMobile":"styles_rootMobile__2gPKG"};